import { useForm } from "react-hook-form";
import { AlertDialog } from "../../common/AlertDailog";
import DynamicForm from "../../common/DynamicForm";

const EditFieldDetails = (props: any) => {
  const booleanOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  const fields: any = [
    {
      name: "field",
      label: "Field",
      size: 4,
    },
    {
      name: "headerName",
      label: "Column Name",
      size: 4,
    },
    {
      name: "cmp",
      label: "Display Type",
      size: 4,
      inputType: "dropdown",
      options: [
        { value: "link", label: "Link" },
        { value: "chip", label: "Chip" },
        { value: "Chip", label: "Chip" },
        { value: "icon", label: "Icon" },
      ],
    },
    {
      name: "type",
      label: "Column Type",
      size: 4,
      inputType: "dropdown",
      options: [
        { value: "number", label: "Number" },
        { value: "singleSelect", label: "Single select" },
        { value: "multiSelect", label: "Multi select" },
        { value: "date", label: "Date" },
        { value: "dateTime", label: "Date time" },
      ],
    },
    {
      name: "width",
      label: "Width",
      size: 4,
      inputType: "number",
      type: "tel",
    },
    {
      name: "flex",
      label: "Flex",
      size: 4,
      inputType: "number",
      type: "tel",
    },
    {
      name: "sortable",
      label: "Sortable",
      size: 4,
      inputType: "dropdown",
      options: booleanOptions,
    },
    {
      name: "filterable",
      label: "Filterable",
      size: 4,
      inputType: "dropdown",
      options: booleanOptions,
    },
    {
      name: "basic_search",
      label: "Basic Search",
      size: 4,
      inputType: "dropdown",
      options: booleanOptions,
    },
    {
      name: "advanced_search",
      label: "Adv Search",
      size: 4,
      inputType: "dropdown",
      options: booleanOptions,
    },
    {
      name: "codelist_associated",
      label: "Codelist Associated",
      size: 4,
    },
  ];
  const {
    fieldEditPopup,
    setFieldEditPopup,
    selectedFieldData,
    handleSaveField,
  } = props;

  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
  } = useForm({
    defaultValues: selectedFieldData,
  });
  // {
  // resolver: zodResolver(
  //   viewType == "Details Component"
  //     ? detailsAddComponentSchema
  //     : addComponentSchema
  // ),
  // defaultValues:
  //   viewType == "Details Component" ? { component_type: "Card" } : {},
  //   }

  //   const handleSave = (data: any) => {
  //     console.debug(data);
  //   };

  const OnInvalid = (data: any) => {
    console.debug(data);
  };

  return (
    <AlertDialog
      open={fieldEditPopup}
      handleClose={() => setFieldEditPopup(false)}
      handleConfirm={handleSubmit(handleSaveField, OnInvalid)}
      maxWidth="md"
      title="Edit Field"
    >
      <DynamicForm
        fieldsJson={fields}
        register={register}
        control={control}
        errors={errors}
      />
    </AlertDialog>
  );
};

export default EditFieldDetails;
